module.exports = __webpack_public_path__ + "static/pattern-1496e7835a804af713218bc921746c50.svg";